import React from 'react';
import PropTypes, { any } from 'prop-types';

import MatchSheetMatchData from './OfficialPrintComponents/MatchSheetMatchData';
import MatchSheetHeader from './OfficialPrintComponents/MatchSheetHeader';
import MatchSheetPlayerData from './OfficialPrintComponents/MatchSheetPlayerData';
import MatchSheetRoundData from './OfficialPrintComponents/MatchSheetRoundData';
import MatchSheetScoreData from './OfficialPrintComponents/MatchSheetScoreData';

import { shouldDisplayWinnerAndScoreData } from '../../utils/matchScorePrintPage';

import styles from './officialSingle.scss';

const OfficialSingle = ({ hasBreak, match }) => {
    const shouldDisplayWinnerScoreData = shouldDisplayWinnerAndScoreData(match);

    return (
        <div className={hasBreak ? styles.officialSingleWrapperBreakAfter : styles.officialSingleWrapper}>
            <div className={styles.officialSingle}>
                <MatchSheetHeader
                    match={match}
                />
                <MatchSheetMatchData
                    match={match}
                    showReferee
                />
                <div className={styles.data}>
                    <MatchSheetPlayerData
                        match={match}
                        positionType="positionOne"
                    />
                    {!shouldDisplayWinnerScoreData && (
                        <MatchSheetRoundData
                            roundsToDisplay={1}
                            match={match}
                        />
                    )}
                </div>
                <MatchSheetScoreData
                    match={match}
                />
                <div className={`${styles.data} ${styles.invert}`}>
                    <MatchSheetPlayerData
                        match={match}
                        positionType="positionTwo"
                        addTopBorder
                    />
                    {!shouldDisplayWinnerScoreData && (
                        <MatchSheetRoundData
                            roundsToDisplay={1}
                            match={match}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default OfficialSingle;

OfficialSingle.propTypes = {
    hasBreak: PropTypes.bool,
    match: PropTypes.objectOf(any).isRequired,
};

OfficialSingle.defaultProps = {
    hasBreak: true,
};
